module.exports = __webpack_public_path__ + "img/hic-transport-accidents-female.bcb490c3.png";